export default __webpack_public_path__ + "static/audio-cardio-4-aa-0467d6102229e57e7c9c6082cc81f3d3.webp";